__turbopack_context__.v({
  "root": "SvgIcon-module__RU1m0G__root",
});
